import ApiService from "./api.service";
import mainStore from "../store/mainStore";

class ClientInvoiceDataService extends ApiService {
    async getClientInvoiceData() {
        const response = await this.get("api/meeting/client-invoice-data");
        if (response.status !== 200) {
            throw await Promise.reject(response);
        }

        mainStore.commit("setClientInvoiceData", response.data);
        return response;
    }

    async getClientInvoiceGusData(nip) {
        const response = await this.get(`api/meeting/client-invoice-data/${nip}/gus-data`);
        if (response.status !== 200) {
            throw await Promise.reject(response);
        }

        return response;
    }

    async getBuyerGroups() {
        const response = await this.get("api/meeting/client-invoice-data/buyer-groups");
        if (response.status !== 200) {
            throw await Promise.reject(response);
        }

        return response;
    }

    async getRecipientRoles() {
        const response = await this.get("api/meeting/client-invoice-data/recipient-roles");
        if (response.status !== 200) {
            throw await Promise.reject(response);
        }

        return response;
    }

    async updateClientInvoiceData(id, data) {
        const response = await this.put(`api/meeting/client-invoice-data/${id}`, data);
        if (response.status !== 204) {
            throw await Promise.reject(response);
        }

        return await this.getClientInvoiceData();
    }

    async createClientInvoiceData(data) {
        const response = await this.post(`api/meeting/client-invoice-data`, data);
        if (response.status !== 200) {
            throw await Promise.reject(response);
        }

        return await this.getClientInvoiceData();
    }

    async getGusData(nip) {
        const response = await this.get(`api/meeting/client-invoice-data/${nip}/gus-data`);
        if (response.status !== 200) {
            throw await Promise.reject(response);
        }
        return response;
    }
}

export default new ClientInvoiceDataService();
